import Cookies from 'js-cookie';

const cookieDomain = import.meta.env.VITE_REFERRAL_CODE_COOKIE_DOMAIN;

const REFERRAL_CODE_COOKIE = 'sibill_referral_code';

const referralCookieAttributes: Cookies.CookieAttributes = {
  domain: cookieDomain,
  path: '/',
  sameSite: 'Lax',
  secure: !cookieDomain?.includes('localhost'),
  expires: 365,
};

export const setReferralCodeCookie = (code: string): void => {
  Cookies.set(REFERRAL_CODE_COOKIE, code, referralCookieAttributes);
};

export const clearReferralCodeCookie = (): void => {
  Cookies.remove(REFERRAL_CODE_COOKIE, referralCookieAttributes);
};
